export const APPINSIGHTS_STRINGS = {
  PLANT_ADDED: "Plant: add plant",
  PLANT_EDITED: "Plant: edit plant",
  PREDICT_CIP_CLICKED: "Predict CIP: clicked",
  PROCEED_TO_ANALYSIS_CLICKED : "Proceed to Analysis: clicked",
  XTP_LEARN_MORE_CLICKED: "XTP: learn more clicked",
  CIP_EDITED: "CIP: edited",
  CIP_DELETED: "CIP: deleted",
  CIP_ADDED: "CIP: added",
};
